module.exports = __webpack_public_path__ + "media/images/icons/money-c73934906fe2eb6e3d6923e3dbe6902d.svg";